import React from "react";

export default function TrophyCabinet({ trophies = [] }) {
  return (
    <section className="league-panel league-profile-section">
      <div className="league-panel-head"><div><p>Honours</p><h2>Trophy cabinet</h2></div><span>{trophies.length} honours</span></div>
      <div className="league-trophy-grid">
        {trophies.length ? trophies.map((trophy) => (
          <article key={trophy.id}><i>{trophy.icon}</i><strong>{trophy.title}</strong><span>{trophy.season}</span></article>
        )) : <div className="league-empty">Historical honours will appear after a season is archived.</div>}
      </div>
    </section>
  );
}
